module.exports = __webpack_public_path__ + "static/aon-overview-8ea4513661d2ba63cf5073fad698da83.png";